import axios from 'axios';
const xsAPI = axios.create({
  // baseURL: 'https://mc-api.douai.co',
  // baseURL: 'http://localhost:8080',
  timeout: 30 * 60 * 1000
});
xsAPI.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const userCode = localStorage.getItem('user_code');

  if (userCode) {
    if (config.url.includes('?')) {
      config.url = `${config.url}&UserCode=${userCode}`;
    } else {
      config.url = `${config.url}?UserCode=${userCode}`;
    }
  }

  return config;
}, error => {
  return Promise.reject(error);
});
xsAPI.interceptors.response.use(response => {
  return response;
}, error => {
  const {
    status
  } = error.response;
  console.log(status, error);

  if (status === 401) {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
  }

  return Promise.reject(error);
});
export default xsAPI;